import styles from "./not-found.module.css";
import { Button } from "antd";
import Utils from "../../../utils";

const NotFound = () => {
  return (
    <div className={styles.errorPage}>
      <p className={styles.zoom_area}>
        Oops! Could not find requested resource.
      </p>
      <section className={styles.error_container}>
        <span className={styles.four}>
          <span className={styles.screen_reader_text}>4</span>
        </span>
        <span className={styles.zero}>
          <span className={styles.screen_reader_text}>0</span>
        </span>
        <span className={styles.four}>
          <span className={styles.screen_reader_text}>4</span>
        </span>
      </section>
      <div className={styles.link_container}>
        <Button
          type='default'
          onClick={() => Utils.redirectUrl(`/dashboard`)}
        >
          Return to Home Page
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
